// extracted by mini-css-extract-plugin
export default {"root":"IconOvenFill_root__74LJI"};